module.exports = __webpack_public_path__ + "assets/a613904272a2d643ef7cc49567a45eee.svg";